import { render, staticRenderFns } from "./FormVendorDocument.vue?vue&type=template&id=5f6e8d05&scoped=true"
import script from "./FormVendorDocument.vue?vue&type=script&lang=js"
export * from "./FormVendorDocument.vue?vue&type=script&lang=js"
import style0 from "./FormVendorDocument.vue?vue&type=style&index=0&id=5f6e8d05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e8d05",
  null
  
)

export default component.exports